import * as Sentry from '@sentry/browser';
import {cookies, environment} from './constants-enumerate';
import Cookie from 'js-cookie';
import {Integrations} from '@sentry/tracing';

const RELEASE = `aa-marketing-web-client@${process.env.RELEASE}`;
const IGNORE_ERRORS = ['Route Not Found'];

/**
 *
 * @class SentryService
 */
class SentryService {
  /**
   *
   * @static
   */
  static init() {
    return Sentry.init({
      dsn: 'https://30004a89170449a0870ce3f88c7b27f7@o968153.ingest.sentry.io/5976572',
      release: RELEASE,
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.3,
      environment: SentryService.getEnvironment(),
      ignoreErrors: IGNORE_ERRORS
    });
  }
  /**
   *
   */
  static getEnvironment() {
    if (environment.DEV) return 'development';
    if (environment.STAGE) return 'staging';
    if (environment.PROD) return 'production';
  }
  /**
   *
   */
  static configureInitialScope() {
    return Sentry.configureScope(function(scope) {
      scope.setTag('inApp', environment.IN_APP);

      if (environment.IN_APP) {
        scope.setTag(cookies.APP_STORE, Cookie.get(cookies.APP_STORE));
      }

      scope.setTag(cookies.DEVICE_ID, Cookie.get(cookies.DEVICE_ID));
      scope.setTag(cookies.APP_SESSION_ID, Cookie.get(cookies.APP_SESSION_ID));
      scope.setTag(cookies.COUNTRY_CODE, Cookie.get(cookies.COUNTRY_CODE));
      scope.setTag(cookies.REGION, Cookie.get(cookies.REGION));
    });
  }
  /**
   *
   * @static
   */
  static get severity() {
    return Sentry.Severity;
  }
  /**
   *
   * @param {Object} options
   */
  static addBreadcrumb(options) {
    return Sentry.addBreadcrumb(options);
  }
  /**
   *
   * @param {Object} options
   */
  static setUser(options) {
    return Sentry.setUser(options);
  }
  /**
   *
   * @param {Object} msg
   */
  static captureMessage(msg) {
    return Sentry.captureMessage(msg);
  }
  /**
   *
   * @param {Object} err
   */
  static captureException(err, context = {}) {
    return Sentry.captureException(err, context);
  }
  /**
   *
   * @param {String} name
   * @param {Object} [context={}]
   */
  static setContext(name, context = {}) {
    return Sentry.setContext(name, context);
  }
}

export {
  SentryService
};
